var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoadingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 399.26 381.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M226.86,81.67c5.01,0,9.07-4.06,9.07-9.07s-4.06-9.07-9.07-9.07-9.08,4.06-9.08,9.07,4.07,9.07,9.08,9.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.97,81.67c5.01,0,9.07-4.06,9.07-9.07s-4.06-9.07-9.07-9.07-9.08,4.06-9.08,9.07,4.07,9.07,9.08,9.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.63,117.96c5.01,0,9.07-4.06,9.07-9.07s-4.06-9.07-9.07-9.07-9.08,4.06-9.08,9.07,4.07,9.07,9.08,9.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.08,117.96c5.01,0,9.07-4.06,9.07-9.07s-4.06-9.07-9.07-9.07-9.08,4.06-9.08,9.07,4.07,9.07,9.08,9.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.3,81.67c5.01,0,9.07-4.06,9.07-9.07s-4.06-9.07-9.07-9.07-9.08,4.06-9.08,9.07,4.07,9.07,9.08,9.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.52,117.96c5.01,0,9.07-4.06,9.07-9.07s-4.06-9.07-9.07-9.07-9.08,4.06-9.08,9.07,4.07,9.07,9.08,9.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.75,117.96c5.01,0,9.07-4.06,9.07-9.07s-4.06-9.07-9.07-9.07-9.08,4.06-9.08,9.07,4.07,9.07,9.08,9.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.41,81.67c5.01,0,9.07-4.06,9.07-9.07s-4.06-9.07-9.07-9.07-9.08,4.06-9.08,9.07,4.07,9.07,9.08,9.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.19,117.96c5.01,0,9.07-4.06,9.07-9.07s-4.06-9.07-9.07-9.07-9.08,4.06-9.08,9.07,4.07,9.07,9.08,9.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.37,163.33H353.89c15.01,0,27.22-12.21,27.22-27.22v-18.15C381.11,50.71,303.09,0,199.63,0S18.15,50.71,18.15,117.96v18.15c0,15.01,12.21,27.22,27.22,27.22Zm-9.07-45.37c0-55.97,71.75-99.81,163.33-99.81s163.33,43.84,163.33,99.81v18.15c0,5.01-4.07,9.07-9.07,9.07H45.37c-5,0-9.07-4.07-9.07-9.07v-18.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.22,199.63H211.82c7.16,0,14.18,2.91,19.25,7.98l18.15,18.15c8.85,8.84,20.46,13.27,32.08,13.27s23.24-4.42,32.08-13.27l18.15-18.15c5.07-5.07,12.08-7.98,19.25-7.98h21.26c5.01,0,9.07-4.06,9.07-9.07s-4.06-9.07-9.07-9.07h-21.26c-12.11,0-23.51,4.72-32.08,13.29l-18.15,18.15c-10.62,10.6-27.89,10.6-38.5,0l-18.15-18.15c-8.57-8.57-19.96-13.29-32.08-13.29H27.22c-5.01,0-9.07,4.06-9.07,9.07s4.06,9.07,9.07,9.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.89,290.37H45.37c-15.01,0-27.22,12.21-27.22,27.22v18.15c0,25.02,20.35,45.37,45.37,45.37H335.74c25.02,0,45.37-20.35,45.37-45.37v-18.15c0-15.01-12.21-27.22-27.22-27.22Zm9.07,45.37c0,15.01-12.21,27.22-27.22,27.22H63.52c-15.01,0-27.22-12.21-27.22-27.22v-18.15c0-5.01,4.07-9.07,9.07-9.07H353.89c5,0,9.07,4.07,9.07,9.07v18.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.04,217.78h-18.15c-5.01,0-9.07,4.06-9.07,9.07s4.06,9.07,9.07,9.07h18.15c5,0,9.07,4.07,9.07,9.07s-4.07,9.07-9.07,9.07H27.22c-5,0-9.07-4.07-9.07-9.07s4.07-9.07,9.07-9.07H208.7c5.01,0,9.07-4.06,9.07-9.07s-4.06-9.07-9.07-9.07H27.22c-15.01,0-27.22,12.21-27.22,27.22s12.21,27.22,27.22,27.22H372.04c15.01,0,27.22-12.21,27.22-27.22s-12.21-27.22-27.22-27.22Z",
    style: {
      fill: "#fff"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingIcon);
export default __webpack_public_path__ + "static/media/loadingIcon.c12b793ea70cf9565680a5a57352f6ce.svg";
export { ForwardRef as ReactComponent };